import api from './api.js'

export default {
    authenticate: (user) =>
        api.post('/authentication', { user })
            .then(res => res.data).catch(e => console.log(e))
}
